import axios from '@/axios.js'
import {getApp} from '../../utils/utils';
export default {
  namespaced: true,
  state: {
    delivery:[],
    deliveryOrder: []
  },
  getters: {
    getDelivery:state=>{
      return state.delivery;
    },
    getDeliveryOrder:state=>{
      return state.deliveryOrder;
    }
  },
  mutations: {
    GET_DELIVERY(state,payload){
      state.delivery = payload
    },
    GET_DELIVERY_ORDER(state,payload){
      state.deliveryOrder = payload
    }
  },
  actions: {
    //Used to get all data
    getDelivery({ commit }, params){
      return new Promise((resolve, reject) => {
      axios
          .get('/manufacture/master-data/delivery?props[app]='+getApp(), {params: params,})
          .then(res => {
            commit('GET_DELIVERY',res.data.data)
            resolve(res.data)
          })
          .catch(err => {
            alert(err);
            reject(err)
          });
      })
    },
    // Create new delivery
    createDelivery({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post('/manufacture/master-data/delivery-module', payload)
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            alert(err);
            reject(err)
          });
      })
    },
    // Get deliveries with pagination
    getDeliveries({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/manufacture/master-data/deliveries-module', { params })
          .then(res => {
            commit('GET_DELIVERY_ORDER', res.data.data)
            resolve(res.data.pagination)
          })
          .catch(err => {
            reject(err)
          });
      })
    },
    // Get delivery by ID
    getDeliveryById({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/manufacture/master-data/delivery-module/${id}`)
          .then(res => {
            resolve(res.data.data)
          })
          .catch(err => {
            reject(err)
          });
      })
    },
    // Update delivery status
    updateDeliveryStatus({ commit }, { id, status }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`/manufacture/master-data/delivery-module/${id}/status`, { status })
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            alert(err);
            reject(err)
          });
      })
    },
    processDelivery({ commit }, { id, action }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`/manufacture/master-data/delivery-module/${id}/${action}`)
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          });
      })
    }
  }
}
